/** The canvas: menus, rail, time pages, ruler, switcher, toolbars and banners. */
export default {
  // Canvas context menu
  fitAllFrames: "Fit all frames",
  addNote: "Add note",
  newDoc: "New Doc",
  pasteAsDoc: "Paste as Doc",
  askDenkerHere: "Ask Denker here",
  forward: "Forward",
  search: "Search",
  settings: "Settings",

  // Left rail and agent dock
  addAgent: "Add agent",
  fitView: "Fit view",
  pan: "Pan",
  zoomIn: "Zoom in",
  zoomOut: "Zoom out",

  // Time pages
  timePageRecent: "Recent",
  timePageOlder: "Older",
  timePagesNav: "Canvas time pages",
  timePageFrames: { one: "{count} frame", other: "{count} frames" },
  timePageNumbered: "{number} · {label}",
  timePageAria: "{title}, {frames}",
  selectAllInPage: "Select all in page",
  hidePage: "Hide page",

  // Background tone
  setColorPatterns: "Set magic color patterns",
  backgroundGradient: "Background gradient",
  gradientHandle: "Gradient handle {id}",
  gradientBrightness: "Adjust canvas gradient brightness",
  gradientPreset: "Set gradient preset {number}",

  // Paste as note
  pasteUnavailable: "Paste unavailable",
  clipboardUnreadable: "Clipboard text cannot be read in this browser.",
  clipboardEmpty: "Clipboard is empty",
  clipboardEmptyHint: "Copy text first, then paste it as a Doc.",
  pasteFailed: "Paste failed",
  clipboardReadFailed: "Could not read clipboard.",

  // Creating frames
  unknownError: "Unknown error",
  createNoteFailed: "Failed to create note",
  createTerminalFailed: "Failed to create terminal",

  // Frame ruler
  navigateToCluster: {
    one: "Navigate to {label} cluster, {count} frame",
    other: "Navigate to {label} cluster, {count} frames",
  },
  navigateTo: "Navigate to {title}",
  focusThisFrame: "Focus this frame",

  // Frame tools
  toolTerminal: "Terminal",
  toolTaskBoard: "Task board",
  toolMemory: "Memory",
  frameTools: "Frame tools",
  createFrame: "Create frame",

  // Multi-selection menu
  framesSelected: {
    one: "{count} frame selected",
    other: "{count} frames selected",
  },
  focusTheseWindows: "Focus these windows",
  expand: "Expand",
  pinToLeft: "Pin to left",
  hide: "Hide",
  deleteFramesTitle: "Delete frames",
  deleteFramesDescription: {
    one: "Permanently delete {count} frame? This action cannot be undone.",
    other: "Permanently delete {count} frames? This action cannot be undone.",
  },

  // Directory permission card
  directoryAccessRequired: "Directory access required",
  directoriesNeedPermission: {
    one: "1 directory needs permission",
    other: "{count} directories need permission",
  },
  grantAccess:
    "Grant access in <b>System Settings > Privacy & Security > Files and Folders</b> for Denker Companion, then click Retry.",
  skipping: "Skipping…",
  skipDirectories: "Skip directories",
  checking: "Checking…",
  retry: "Retry",

  // Selection toolbar
  highlightsFrameTitle: "Highlights",
  savedToHighlights: "Saved to Highlights",
  highlightRemoved: "Highlight removed",
  highlight: "Highlight",
  unhighlight: "Unhighlight",
  selectionAskDenker: "Ask Denker",
  askDenkerPlaceholder: "Ask Denker…",
  askDenkerSend: "Send to Denker",

  // Project and space switcher
  addProject: "Add project",
  newProject: "New project",
  addSpace: "Add space",
  newSpace: "New space",
} as const;
